export class Shopware6ProductConfiguration {

  constructor(
    public excludeFromExport: boolean = false
  ) {
  }
}



